export default __webpack_public_path__ + "static/person-hero-bg-aa3b0e8df0f6538c4fbe5963c757ae28.svg";